import { marked } from 'marked';
import DOMPurify from 'dompurify';
import TurndownService from 'turndown';


function convertMarkdownToHtml(markdownText) {
    try {
      const rawHtml = marked.parse(markdownText || '');
      const cleanHtml = DOMPurify.sanitize(rawHtml);
      return cleanHtml;
    } catch (err) {
      console.error('Error converting Markdown to HTML :', err);
      return markdownText;
    }
  }

function convertHTMLtoMarkdown(html) {
  try{
    const turndownService = new TurndownService();
    const markdownBack = turndownService.turndown(html);
    return markdownBack;
  }
  catch(err){
    console.error(`Error converrting HTML to markdown`, err);
  }
    
}

export { convertMarkdownToHtml, convertHTMLtoMarkdown };
